import { useState, useEffect } from 'react';
import { fetchModels } from 'shared/store';

const useFetchModels = (endpoint, modelType, ModelClass) => {
  const [models, setModels] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!endpoint) {
      return;
    }

    const fetchData = async () => {
      setIsLoading(true);
      let fetchedModels = await fetchModels(endpoint, modelType);
      if (ModelClass) {
        fetchedModels = fetchedModels.map(model => new ModelClass(model));
      }
      setModels(fetchedModels);
      setIsLoading(false);
    };
    fetchData();
  }, [endpoint, modelType]);

  return [models, isLoading];
};

export default useFetchModels;
